import React, { useEffect, useState } from "react";
import {
  Box,
  Stepper,
  Step,
  StepLabel,
  Button,
  Typography,
  TextField,
  Grid,
  Paper,
  MenuItem,
} from "@mui/material";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";

import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import {
  createCustomerService,
  getCustomerByIdService,
  updateCustomerService,
} from "../../services/customerService";
import { getAllAgentsService } from "../../services/agentService";
import { imageUploadService } from "../../services/imageUploadService";
import useStore from "../../useStore";

const steps = ["Customer Information", "Guarantor Information"];

const validationSchema = Yup.object({
  userName: Yup.string(),
  phoneNumber: Yup.string(),
  userPhoto: Yup.string().url("Invalid URL"),
  alternativePhoneNumber1: Yup.string(),
  alternativePhoneNumber2: Yup.string(),
  password: Yup.string(),
  email: Yup.string().email("Invalid email"),
  address: Yup.string(),
  landmark: Yup.string(),
  locationLink: Yup.string(),
  workLocationLink: Yup.string(),
  customerPhoto: Yup.string().url("Invalid URL"),
  houseImage: Yup.string().url("Invalid URL"),
  aadhaarNumber: Yup.string(),
  aadhaarImage: Yup.string().url("Invalid URL"),
  panNumber: Yup.string(),
  panImage: Yup.string().url("Invalid URL"),
  propertyHolderName: Yup.string(),
  propertyDetails: Yup.string(),
  propertyPhoto: Yup.string().url("Invalid URL"),
  rcHolderName: Yup.string(),
  rcImage: Yup.string().url("Invalid URL"),
  chequeNumber: Yup.string(),
  chequeImage: Yup.string().url("Invalid URL"),
  loanIssuedOn: Yup.string(),
  guarantorName: Yup.string(),
  guarantorPhoneNumber: Yup.string(),
  guarantorAddress: Yup.string(),
  guarantorLandmark: Yup.string(),
  guarantorLocationLink: Yup.string(),
  guarantorHouseImage: Yup.string().url("Invalid URL"),
  guarantorAadhaarNumber: Yup.string(),
  guarantorAadhaarImage: Yup.string().url("Invalid URL"),
  guarantorPanNumber: Yup.string(),
  guarantorPanImage: Yup.string().url("Invalid URL"),
  guarantorDrivingLicence: Yup.string(),
  guarantorDrivingLicenceImage: Yup.string().url("Invalid URL"),
  guarantorChequeNumber: Yup.string(),
  guarantorChequeImage: Yup.string().url("Invalid URL"),
  // agent: Yup.string(),
  // loanAmount: Yup.number(),
  // frequency: Yup.string(),
  // startDate: Yup.date(),
  // collectionDay: Yup.string(),
  // endDate: Yup.date(),
  // processingFee: Yup.number(),
  // interestAmount: Yup.number(),
  // loanTenure: Yup.string(),
  // amountToBePaidBy: Yup.string(), // Validation for missing field
  // disbursedAmount: Yup.number(),
  // collectionAmount: Yup.number(),
  // interest: Yup.number(), // Validation for missing field
  // insuranceFee: Yup.number(), // Validation for missing field
  // penaltyAmount: Yup.number(), // Validation for missing field
});

const CreateGroupCustomer = () => {
  const [activeStep, setActiveStep] = React.useState(0);
  const navigate = useNavigate();
  const [customer, setCustomer] = useState();
  const [phoneNumber, setPhoneNumber] = useState();
  const [email, setEmail] = useState();
  const [alternativePhoneNumber1, setAlternativePhoneNumber1] = useState();
  const { isUpdate, editUserId } = useStore();
  console.log(isUpdate, editUserId);

  const fetchCustomerDetails = async () => {
    try {
      const response = await getCustomerByIdService(editUserId);
      setCustomer(response);
      response?.contacts.forEach((contact) => {
        switch (contact?.contactType) {
          case "phone":
            setPhoneNumber(contact.contactValue);
            break;
          case "email":
            setEmail(contact.contactValue);
            break;
          case "atl1":
            setAlternativePhoneNumber1(contact.contactValue);
            break;
          default:
            break;
        }
      });
      //Formik.setFieldValue("userName", response?.user?.userName);
      //setLoading(false);
    } catch (err) {
      toast.error(err.message);
      //setLoading(false);
    }
  };
  useEffect(() => {
    if (isUpdate) fetchCustomerDetails();
  }, [editUserId]);

  const PhotoField = ({ name, label, handleFileUpload }) => (
    <Grid item xs={3}>
      <Typography mt={1}>{label}</Typography>
      <Field name={name}>
        {({ field, form }) => (
          <TextField
            fullWidth
            size="small"
            type="file"
            sx={{
              "& .MuiInputBase-root": {
                fontSize: "0.875rem", // Smaller font size
                borderRadius: "8px", // Adjust this value for border radius
              },
            }}
            onChange={(event) => {
              const file = event.currentTarget.files[0];
              handleFileUpload(file, form.setFieldValue, field.name);
            }}
          />
        )}
      </Field>
    </Grid>
  );
  const handlePanChange = (e, setFieldValue, isCus) => {
    let value = e.target.value.toUpperCase(); // Convert to uppercase
    value = value.replace(/[^A-Z0-9]/g, ""); // Remove non-alphanumeric characters

    // Enforce correct structure: 5 letters, 4 numbers, 1 letter
    if (value.length > 10) {
      value = value.slice(0, 10);
    }

    if (value.length <= 5) {
      value = value.replace(/[^A-Z]/g, ""); // First 5 should be letters
    } else if (value.length <= 9) {
      value = value.replace(/^(.{5})[^0-9]*/, "$1"); // Next 4 should be numbers
    } else {
      value = value.replace(/^(.{5}\d{4})[^A-Z]*/, "$1"); // Last character should be a letter
    }
    if (isCus) {
      setFieldValue("panNumber", value); // Update Formik state
    } else {
      setFieldValue("guarantorPanNumber", value); // Update Formik state
    }
  };
  const handleFileUpload = async (file, setFieldValue, fieldName) => {
    if (!file) {
      toast.error("Please select a file to upload");
      return;
    }

    const allowedExtensions = [
      "image/jpeg",
      "image/png",
      "image/jpg",
      "image/webp",
    ];

    if (!allowedExtensions.includes(file.type)) {
      toast.error("Only image files (jpg, jpeg, png, webp) are allowed.");
      return;
    }

    const formData = new FormData();
    formData.append("image", file);

    try {
      const imageUrl = await imageUploadService(formData);
      setFieldValue(fieldName, imageUrl);
    } catch (error) {
      toast.error("Image upload failed. Please try again.");
      console.error(error);
    }
  };

  const isLastStep = activeStep === steps.length - 1;

  const handleNext = () => setActiveStep((prev) => prev + 1);
  const handleBack = () => setActiveStep((prev) => prev - 1);
  const [agents, setAgents] = useState([]);

  const fetchAgents = async () => {
    try {
      const agents = await getAllAgentsService();
      setAgents(agents?.agentsWithPhoneContacts); // Adjust this based on API response structure
    } catch (err) {
      toast.error(err.message);
    }
  };
  //   const calculateCollectionAmount = (values, tenure) => {
  //     if (values.loanAmount) {
  //       const collectionAmount = values.loanAmount / tenure;
  //       return { amount: collectionAmount };
  //     }
  //   };
  //   const calculateInterestAndCollection = (values) => {
  //     if (values.loanAmount) {
  //       const totalAmount = (values.loanAmount * values.interest) / 100;
  //       const collectionAmount =
  //         (totalAmount + values.loanAmount) / values.loanTenure;
  //       return { amount: collectionAmount };
  //     }
  //   };
  //   const calculateInterest = (values) => {
  //     const collectionAmount = (values.loanAmount * values.interest) / 100;
  //     // const collectionAmount = InterestAmount / values.loanTenure;
  //     return { amount: collectionAmount };
  //   };

  //   const calculateEndDate = (values, frequency) => {
  //     let startDate = new Date();
  //     let endDate = new Date(startDate); // Copy startDate

  //     if (frequency === "daily") {
  //       // Manually set the date to ensure consistent day handling
  //       endDate.setDate(startDate.getDate() + values?.loanTenure);
  //     } else if (frequency === "weekly") {
  //       endDate.setDate(startDate.getDate() + values?.loanTenure * 7);
  //     } else if (frequency === "monthly") {
  //       // Use setMonth to ensure correct day handling for monthly frequencies
  //       endDate.setMonth(startDate.getMonth() + values?.loanTenure);

  //       // Ensure that the day of the month stays consistent
  //       if (startDate.getDate() !== endDate.getDate()) {
  //         // If the month change pushes it to the next month (e.g., from 31st to 1st),
  //         // we manually set the date to match the start date.
  //         endDate.setDate(startDate.getDate());
  //       }
  //     }

  //     // Return consistent date formats
  //     return {
  //       startDate: startDate.toISOString().split("T")[0],
  //       endDate: endDate.toISOString().split("T")[0],
  //     };
  //   };
  // const customerFields = [
  //   "userName",
  //   "phoneNumber",
  //   "userPhoto",
  //   "alternativePhoneNumber1",
  //   "alternativePhoneNumber2",
  //   "password",
  //   "email",
  //   "address",
  //   "landmark",
  //   "locationLink",
  //   "workLocationLink",
  //   "housePhoto",
  //   "aadhaarNumber",
  //   "aadhaarPhoto",
  //   "panNumber",
  //   "panPhoto",
  //   "accountNumber",
  //   "accountName",
  //   "IFSC",
  //   "branch",
  //   "bankName",
  //   "passBookImage",
  //   "signatureImage",
  //   // "propertyHolderName",
  //   // "propertyDetails",
  //   // "propertyPhoto",
  //   // "rcHolderName",
  //   // "rcImage",
  //   // "chequeNumber",
  //   // "chequeImage",
  //   "loanIssuedOn",
  // ];

  // const guarantorFields = [
  //   "guarantorName",
  //   "guarantorPhoneNumber",
  //   "guarantorAddress",
  //   "guarantorLandmark",
  //   "guarantorLocationLink",
  //   "guarantorHousePhoto",
  //   "guarantorAadhaarNumber",

  //   "guarantorPanNumber",

  //   "guarantorChequeNumber",
  // ];

  const handleSubmit = async (values, actions) => {
    console.log("else");
    if (isLastStep) {
      try {
        // const requiredFields = guarantorFields;

        // // Find empty fields
        // const emptyFields = requiredFields.filter((field) => !values[field]);

        // if (emptyFields.length > 0) {
        //   const formattedFields = emptyFields
        //     .map((field) => field.replace(/([A-Z])/g, " $1"))
        //     .join(", ");

        //   toast.error(`Please fill the required fields: ${formattedFields}`);
        //   return; // Stop navigation
        // }
        if (isUpdate) {
          const createCustomer = await updateCustomerService(
            values,
            true,
            editUserId
          );
          if (createCustomer.status === "success") {
            toast.success("Customer updated successfully");
            // Navigate to the dashboard
            navigate("/group-customer");
          }
        } else {
          const createCustomer = await createCustomerService(values, true);
          if (createCustomer.status === "success") {
            toast.success("Customer created successfully");
            // Navigate to the dashboard
            navigate("/group-customer");
          }
          actions.setSubmitting(false);
        }
      } catch (error) {
        toast.error(error);
      }
    } else {
      // const requiredFields = customerFields;

      // // Find empty fields
      // const emptyFields = requiredFields.filter((field) => !values[field]);

      // if (emptyFields.length > 0) {
      //   const formattedFields = emptyFields
      //     .map((field) => field.replace(/([A-Z])/g, " $1"))
      //     .join(", ");

      //   toast.error(`Please fill the required fields: ${formattedFields}`);
      //   return; // Stop navigation
      // }
      handleNext();
      actions.setTouched({}); // Reset touched fields
      actions.setSubmitting(false);
    }
  };
  //   function calculateMonthsFromWeeks(weeks) {
  //     const weeksPerMonth = 4.345; // Approximate number of weeks in a month
  //     const months = weeks / weeksPerMonth;
  //     return Math.round(months); // Returns result rounded to the nearest whole number
  //   }
  //   const calculateInterestChange = (interest, values) => {
  //     const months = calculateMonthsFromWeeks(values.loanTenure);
  //     const collectionAmount = (values.loanAmount * interest) / 100;
  //     const interestAmount = collectionAmount * months;
  //     const disbursedAmount = values.loanAmount - interestAmount;
  //     return { interestAmount: interestAmount, disbursedAmount: disbursedAmount };
  //   };
  //   const calculateInterestAndDisbursedAmount = (values) => {
  //     const months = calculateMonthsFromWeeks(values.loanTenure);
  //     const collectionAmount = (values.loanAmount * values.interest) / 100;
  //     const interestAmount = collectionAmount * months;
  //     const disbursedAmount = values.loanAmount - interestAmount;
  //     return { interestAmount: interestAmount, disbursedAmount: disbursedAmount };
  //   };

  useEffect(() => {
    fetchAgents();
  }, []);

  const renderStepContent = (step, values, setFieldValue, handleChange) => {
    switch (step) {
      case 0:
        return (
          <Grid container spacing={2}>
            <Grid item xs={3}>
              <Typography mt={1}>Customer Name</Typography>
              <Field
                fullWidth
                size="small"
                name="userName"
                as={TextField}
                onKeyDown={(e) => {
                  // Allow only alphabets and spaces
                  if (
                    !/[a-zA-Z\s]/.test(e.key) && // Allow alphabets and spaces
                    e.key !== "Backspace" && // Allow Backspace
                    e.key !== "Delete" && // Allow Delete
                    e.key !== "ArrowLeft" && // Allow Left Arrow
                    e.key !== "ArrowRight" // Allow Right Arrow
                  ) {
                    e.preventDefault();
                  }
                }}
                sx={{
                  "& .MuiInputBase-root": {
                    // Smaller font size
                    borderRadius: "8px", // Adjust this value for border radius
                  },
                }}
                inputProps={{
                  onInput: (e) => {
                    e.target.value = e.target.value.replace(/[^a-zA-Z\s]/g, ""); // Allow only alphabets and spaces
                  },
                }}
              />
            </Grid>
            <Grid item xs={3}>
              <Typography mt={1}>Phone Number</Typography>
              <Field
                fullWidth
                size="small"
                name="phoneNumber"
                type="text"
                as={TextField}
                inputProps={{
                  maxLength: 10, // Limits the input to 10 characters
                  inputMode: "numeric", // Brings up a numeric keyboard on mobile devices
                  style: { appearance: "textfield" }, // Remove arrows for most browsers
                }}
                sx={{
                  "& input": {
                    MozAppearance: "textfield", // Remove arrows for Firefox
                  },
                }}
                onInput={(e) => {
                  e.target.value = e.target.value
                    .replace(/[^0-9]/g, "")
                    .slice(0, 10); // Allow only numbers and limit to 10 digits
                }}
              />
            </Grid>
            <Grid item xs={3}>
              <Typography mt={1}>Alternative Phone Number</Typography>
              <Field
                fullWidth
                size="small"
                name="alternativePhoneNumber1"
                as={TextField}
                inputProps={{
                  maxLength: 10, // Limits the input to 10 characters
                  inputMode: "numeric", // Brings up a numeric keyboard on mobile devices
                  style: { appearance: "textfield" }, // Remove arrows for most browsers
                }}
                sx={{
                  "& input": {
                    MozAppearance: "textfield", // Remove arrows for Firefox
                  },
                }}
                onInput={(e) => {
                  e.target.value = e.target.value
                    .replace(/[^0-9]/g, "")
                    .slice(0, 10); // Allow only numbers and limit to 10 digits
                }}
              />
            </Grid>
            <Grid item xs={3}>
              <Typography mt={1}>Alternative Phone Number 2</Typography>
              <Field
                fullWidth
                size="small"
                name="alternativePhoneNumber2"
                as={TextField}
                inputProps={{
                  maxLength: 10, // Limits the input to 10 characters
                  inputMode: "numeric", // Brings up a numeric keyboard on mobile devices
                  style: { appearance: "textfield" }, // Remove arrows for most browsers
                }}
                sx={{
                  "& input": {
                    MozAppearance: "textfield", // Remove arrows for Firefox
                  },
                }}
                onInput={(e) => {
                  e.target.value = e.target.value
                    .replace(/[^0-9]/g, "")
                    .slice(0, 10); // Allow only numbers and limit to 10 digits
                }}
              />
            </Grid>
            <Grid item xs={3}>
              <Typography mt={1}>Password</Typography>
              <Field
                fullWidth
                size="small"
                name="password"
                as={TextField}
                sx={{
                  "& .MuiInputBase-root": {
                    // Smaller font size
                    borderRadius: "8px", // Adjust this value for border radius
                  },
                }}
                type="password"
              />
            </Grid>
            <Grid item xs={3}>
              <Typography mt={1}>Email</Typography>
              <Field
                fullWidth
                size="small"
                name="email"
                as={TextField}
                sx={{
                  "& .MuiInputBase-root": {
                    // Smaller font size
                    borderRadius: "8px", // Adjust this value for border radius
                  },
                }}
              />
            </Grid>
            <PhotoField
              name="userPhoto"
              label="Customer Photo"
              handleFileUpload={handleFileUpload}
            />
            <Grid item xs={3}>
              <Typography mt={1}>Address</Typography>
              <Field
                fullWidth
                size="small"
                name="address"
                as={TextField}
                sx={{
                  "& .MuiInputBase-root": {
                    // Smaller font size
                    borderRadius: "8px", // Adjust this value for border radius
                  },
                }}
              />
            </Grid>
            <Grid item xs={3}>
              <Typography mt={1}>Landmark</Typography>
              <Field
                fullWidth
                size="small"
                name="landmark"
                as={TextField}
                sx={{
                  "& .MuiInputBase-root": {
                    // Smaller font size
                    borderRadius: "8px", // Adjust this value for border radius
                  },
                }}
              />
            </Grid>
            <Grid item xs={3}>
              <Typography mt={1}>Location Link</Typography>
              <Field
                fullWidth
                size="small"
                name="locationLink"
                as={TextField}
                sx={{
                  "& .MuiInputBase-root": {
                    // Smaller font size
                    borderRadius: "8px", // Adjust this value for border radius
                  },
                }}
              />
            </Grid>
            <Grid item xs={3}>
              <Typography mt={1}>Work Location Link</Typography>
              <Field
                fullWidth
                size="small"
                name="workLocationLink"
                as={TextField}
                sx={{
                  "& .MuiInputBase-root": {
                    // Smaller font size
                    borderRadius: "8px", // Adjust this value for border radius
                  },
                }}
              />
            </Grid>
            <PhotoField
              name="housePhoto"
              label="House Image"
              handleFileUpload={handleFileUpload}
            />
            <Grid item xs={3}>
              <Typography mt={1}>Aadhaar Number</Typography>
              <Field
                fullWidth
                size="small"
                name="aadhaarNumber"
                as={TextField}
                onKeyDown={(e) => {
                  // Allow only numbers
                  if (
                    !/[0-9]/.test(e.key) && // Allow digits
                    e.key !== "Backspace" && // Allow Backspace
                    e.key !== "Delete" && // Allow Delete
                    e.key !== "ArrowLeft" && // Allow Left Arrow
                    e.key !== "ArrowRight" // Allow Right Arrow
                  ) {
                    e.preventDefault();
                  }
                }}
                inputProps={{
                  maxLength: 12, // Restrict length to 10
                }}
                sx={{
                  "& .MuiInputBase-root": {
                    // Smaller font size
                    borderRadius: "8px", // Adjust this value for border radius
                  },
                }}
              />
            </Grid>
            <PhotoField
              name="aadhaarPhoto"
              label="Aadhaar Image"
              handleFileUpload={handleFileUpload}
            />
            <Grid item xs={3}>
              <Typography mt={1}>PAN Number</Typography>
              <Field
                fullWidth
                size="small"
                name="panNumber"
                as={TextField}
                inputProps={{
                  maxLength: 10, // Restrict length to 10
                }}
                sx={{
                  "& .MuiInputBase-root": {
                    borderRadius: "8px", // Adjust this value for border radius
                  },
                }}
                onChange={(e) => handlePanChange(e, setFieldValue, true)}
              />
            </Grid>
            <PhotoField
              name="panPhoto"
              label="PAN Image"
              handleFileUpload={handleFileUpload}
            />{" "}
            <PhotoField
              name="signatureImage"
              label="Signature Image"
              handleFileUpload={handleFileUpload}
            />
            <PhotoField
              name="passBookImage"
              label="Pass Book Image"
              handleFileUpload={handleFileUpload}
            />
            <Grid item xs={3}>
              <Typography mt={1}> Account Number</Typography>
              <Field
                fullWidth
                size="small"
                name="accountNumber"
                as={TextField}
                onKeyDown={(e) => {
                  // Allow only numbers
                  if (
                    !/[0-9]/.test(e.key) && // Allow digits
                    e.key !== "Backspace" && // Allow Backspace
                    e.key !== "Delete" && // Allow Delete
                    e.key !== "ArrowLeft" && // Allow Left Arrow
                    e.key !== "ArrowRight" // Allow Right Arrow
                  ) {
                    e.preventDefault();
                  }
                }}
                inputProps={{
                  maxLength: 18, // Restrict length to 10
                }}
                sx={{
                  "& .MuiInputBase-root": {
                    // Smaller font size
                    borderRadius: "8px", // Adjust this value for border radius
                  },
                }}
              />
            </Grid>
            <Grid item xs={3}>
              {" "}
              <Typography mt={1}>Account Name</Typography>
              <Field
                fullWidth
                size="small"
                name="accountName"
                as={TextField}
                onKeyDown={(e) => {
                  // Allow only alphabets and spaces
                  if (
                    !/[a-zA-Z\s]/.test(e.key) && // Allow alphabets and spaces
                    e.key !== "Backspace" && // Allow Backspace
                    e.key !== "Delete" && // Allow Delete
                    e.key !== "ArrowLeft" && // Allow Left Arrow
                    e.key !== "ArrowRight" // Allow Right Arrow
                  ) {
                    e.preventDefault();
                  }
                }}
                sx={{
                  "& .MuiInputBase-root": {
                    // Smaller font size
                    borderRadius: "8px", // Adjust this value for border radius
                  },
                }}
                inputProps={{
                  onInput: (e) => {
                    e.target.value = e.target.value.replace(/[^a-zA-Z\s]/g, ""); // Allow only alphabets and spaces
                  },
                }}
              />
            </Grid>
            <Grid item xs={3}>
              {" "}
              <Typography mt={1}>Bank Name</Typography>
              <Field
                fullWidth
                size="small"
                name="bankName"
                as={TextField}
                onKeyDown={(e) => {
                  // Allow only alphabets and spaces
                  if (
                    !/[a-zA-Z\s]/.test(e.key) && // Allow alphabets and spaces
                    e.key !== "Backspace" && // Allow Backspace
                    e.key !== "Delete" && // Allow Delete
                    e.key !== "ArrowLeft" && // Allow Left Arrow
                    e.key !== "ArrowRight" // Allow Right Arrow
                  ) {
                    e.preventDefault();
                  }
                }}
                sx={{
                  "& .MuiInputBase-root": {
                    // Smaller font size
                    borderRadius: "8px", // Adjust this value for border radius
                  },
                }}
                inputProps={{
                  onInput: (e) => {
                    e.target.value = e.target.value.replace(/[^a-zA-Z\s]/g, ""); // Allow only alphabets and spaces
                  },
                }}
              />
            </Grid>
            <Grid item xs={3}>
              <Typography mt={1}>IFSC</Typography>
              <Field
                fullWidth
                size="small"
                name="IFSC"
                as={TextField}
                sx={{
                  "& .MuiInputBase-root": {
                    borderRadius: "8px",
                  },
                }}
              />
            </Grid>
            <Grid item xs={3}>
              {" "}
              <Typography mt={1}> Branch</Typography>
              <Field
                fullWidth
                size="small"
                name="branch"
                as={TextField}
                onKeyDown={(e) => {
                  // Allow only alphabets and spaces
                  if (
                    !/[a-zA-Z\s]/.test(e.key) && // Allow alphabets and spaces
                    e.key !== "Backspace" && // Allow Backspace
                    e.key !== "Delete" && // Allow Delete
                    e.key !== "ArrowLeft" && // Allow Left Arrow
                    e.key !== "ArrowRight" // Allow Right Arrow
                  ) {
                    e.preventDefault();
                  }
                }}
                sx={{
                  "& .MuiInputBase-root": {
                    // Smaller font size
                    borderRadius: "8px", // Adjust this value for border radius
                  },
                }}
                inputProps={{
                  onInput: (e) => {
                    e.target.value = e.target.value.replace(/[^a-zA-Z\s]/g, ""); // Allow only alphabets and spaces
                  },
                }}
              />
            </Grid>
            <Grid item xs={3}>
              <Typography mt={1}>Loan Issued On</Typography>
              <Field
                fullWidth
                size="small"
                name="loanIssuedOn"
                as={TextField}
                select // This adds the dropdown functionality
                sx={{
                  "& .MuiInputBase-root": {
                    borderRadius: "8px", // Adjust the border radius
                  },
                }}
              >
                {/* Menu items for the dropdown */}
                <MenuItem value="property">Property</MenuItem>
                <MenuItem value="RC">RC</MenuItem>
                <MenuItem value="personal">Personal</MenuItem>
              </Field>
            </Grid>
            {/* {Formik.values.loanIssuedOn === "property" ? <></> } */}
            {values.loanIssuedOn === "property" && (
              <>
                <Grid item xs={3}>
                  <Typography mt={1}>Property Holder Name</Typography>
                  <Field
                    fullWidth
                    size="small"
                    name="propertyHolderName"
                    as={TextField}
                    onKeyDown={(e) => {
                      // Allow only alphabets and spaces
                      if (
                        !/[a-zA-Z\s]/.test(e.key) && // Allow alphabets and spaces
                        e.key !== "Backspace" && // Allow Backspace
                        e.key !== "Delete" && // Allow Delete
                        e.key !== "ArrowLeft" && // Allow Left Arrow
                        e.key !== "ArrowRight" // Allow Right Arrow
                      ) {
                        e.preventDefault();
                      }
                    }}
                    sx={{
                      "& .MuiInputBase-root": {
                        // Smaller font size
                        borderRadius: "8px", // Adjust this value for border radius
                      },
                    }}
                    inputProps={{
                      onInput: (e) => {
                        e.target.value = e.target.value.replace(
                          /[^a-zA-Z\s]/g,
                          ""
                        ); // Allow only alphabets and spaces
                      },
                    }}
                  />
                </Grid>
                <PhotoField
                  name="propertyPhoto"
                  label="Property Photo"
                  handleFileUpload={handleFileUpload}
                />
              </>
            )}
            {values.loanIssuedOn === "RC" && (
              <>
                <Grid item xs={3}>
                  <Typography mt={1}>R C Holder Name</Typography>
                  <Field
                    fullWidth
                    size="small"
                    name="rcHolderName"
                    as={TextField}
                    onKeyDown={(e) => {
                      // Allow only alphabets and spaces
                      if (
                        !/[a-zA-Z\s]/.test(e.key) && // Allow alphabets and spaces
                        e.key !== "Backspace" && // Allow Backspace
                        e.key !== "Delete" && // Allow Delete
                        e.key !== "ArrowLeft" && // Allow Left Arrow
                        e.key !== "ArrowRight" // Allow Right Arrow
                      ) {
                        e.preventDefault();
                      }
                    }}
                    sx={{
                      "& .MuiInputBase-root": {
                        // Smaller font size
                        borderRadius: "8px", // Adjust this value for border radius
                      },
                    }}
                    inputProps={{
                      onInput: (e) => {
                        e.target.value = e.target.value.replace(
                          /[^a-zA-Z\s]/g,
                          ""
                        ); // Allow only alphabets and spaces
                      },
                    }}
                  />
                </Grid>
                <PhotoField
                  name="rcPhoto"
                  label="RC Image"
                  handleFileUpload={handleFileUpload}
                />
              </>
            )}
            {values.loanIssuedOn === "personal" && (
              <>
                <Grid item xs={3}>
                  <Typography mt={1}>Cheque Number</Typography>
                  <Field
                    fullWidth
                    size="small"
                    name="chequeNumber"
                    as={TextField}
                    onKeyDown={(e) => {
                      // Allow only numbers
                      if (
                        !/[0-9]/.test(e.key) && // Allow digits
                        e.key !== "Backspace" && // Allow Backspace
                        e.key !== "Delete" && // Allow Delete
                        e.key !== "ArrowLeft" && // Allow Left Arrow
                        e.key !== "ArrowRight" // Allow Right Arrow
                      ) {
                        e.preventDefault();
                      }
                    }}
                    inputProps={{
                      maxLength: 18, // Restrict length to 10
                    }}
                    sx={{
                      "& .MuiInputBase-root": {
                        // Smaller font size
                        borderRadius: "8px", // Adjust this value for border radius
                      },
                    }}
                  />
                </Grid>
                <PhotoField
                  name="chequePhoto"
                  label="Cheque Image"
                  handleFileUpload={handleFileUpload}
                />
              </>
            )}
          </Grid>
        );
      case 1:
        return (
          <Grid container spacing={2}>
            <Grid item xs={3}>
              <Typography mt={1}>Guarantor Name</Typography>
              <Field
                name="guarantorName"
                as={TextField}
                onKeyDown={(e) => {
                  // Allow only alphabets and spaces
                  if (
                    !/[a-zA-Z\s]/.test(e.key) && // Allow alphabets and spaces
                    e.key !== "Backspace" && // Allow Backspace
                    e.key !== "Delete" && // Allow Delete
                    e.key !== "ArrowLeft" && // Allow Left Arrow
                    e.key !== "ArrowRight" // Allow Right Arrow
                  ) {
                    e.preventDefault();
                  }
                }}
                sx={{
                  "& .MuiInputBase-root": {
                    // Smaller font size
                    borderRadius: "8px", // Adjust this value for border radius
                  },
                }}
                inputProps={{
                  onInput: (e) => {
                    e.target.value = e.target.value.replace(/[^a-zA-Z\s]/g, ""); // Allow only alphabets and spaces
                  },
                }}
                fullWidth
                size="small"
              />
            </Grid>
            <Grid item xs={3}>
              <Typography mt={1}>Guarantor Phone Number</Typography>
              <Field
                name="guarantorPhoneNumber"
                as={TextField}
                inputProps={{
                  maxLength: 10, // Limits the input to 10 characters
                  inputMode: "numeric", // Brings up a numeric keyboard on mobile devices
                  style: { appearance: "textfield" }, // Remove arrows for most browsers
                }}
                sx={{
                  "& input": {
                    MozAppearance: "textfield", // Remove arrows for Firefox
                  },
                }}
                onInput={(e) => {
                  e.target.value = e.target.value
                    .replace(/[^0-9]/g, "")
                    .slice(0, 10); // Allow only numbers and limit to 10 digits
                }}
                fullWidth
                size="small"
              />
            </Grid>
            <PhotoField
              name="guarantorPhoto"
              label="Guarantor Photo"
              handleFileUpload={handleFileUpload}
            />
            <Grid item xs={3}>
              <Typography mt={1}>Guarantor Address</Typography>
              <Field
                name="guarantorAddress"
                as={TextField}
                sx={{
                  "& .MuiInputBase-root": {
                    // Smaller font size
                    borderRadius: "8px", // Adjust this value for border radius
                  },
                }}
                fullWidth
                size="small"
              />
            </Grid>
            <Grid item xs={3}>
              <Typography mt={1}>Guarantor Landmark</Typography>
              <Field
                fullWidth
                size="small"
                name="guarantorLandmark"
                as={TextField}
                sx={{
                  "& .MuiInputBase-root": {
                    // Smaller font size
                    borderRadius: "8px", // Adjust this value for border radius
                  },
                }}
              />
            </Grid>
            <Grid item xs={3}>
              <Typography mt={1}>Guarantor Location Link</Typography>
              <Field
                fullWidth
                size="small"
                name="guarantorLocationLink"
                as={TextField}
                sx={{
                  "& .MuiInputBase-root": {
                    // Smaller font size
                    borderRadius: "8px", // Adjust this value for border radius
                  },
                }}
              />
            </Grid>
            <PhotoField
              name="guarantorHousePhoto"
              label="Guarantor House Image"
              handleFileUpload={handleFileUpload}
            />
            <Grid item xs={3}>
              <Typography mt={1}>Guarantor Aadhaar Number</Typography>
              <Field
                fullWidth
                size="small"
                name="guarantorAadhaarNumber"
                as={TextField}
                onKeyDown={(e) => {
                  // Allow only numbers
                  if (
                    !/[0-9]/.test(e.key) && // Allow digits
                    e.key !== "Backspace" && // Allow Backspace
                    e.key !== "Delete" && // Allow Delete
                    e.key !== "ArrowLeft" && // Allow Left Arrow
                    e.key !== "ArrowRight" // Allow Right Arrow
                  ) {
                    e.preventDefault();
                  }
                }}
                inputProps={{
                  maxLength: 12, // Restrict length to 10
                }}
                sx={{
                  "& .MuiInputBase-root": {
                    // Smaller font size
                    borderRadius: "8px", // Adjust this value for border radius
                  },
                }}
              />
            </Grid>
            {/* <PhotoField
                  name="guarantorAadhaarPhoto"
                  label="Guarantor Aadhaar Image"
                  handleFileUpload={handleFileUpload}
                /> */}

            <Grid item xs={3}>
              <Typography mt={1}>Guarantor PAN Number</Typography>
              <Field
                fullWidth
                size="small"
                name="guarantorPanNumber"
                as={TextField}
                sx={{
                  "& .MuiInputBase-root": {
                    // Smaller font size
                    borderRadius: "8px", // Adjust this value for border radius
                  },
                }}
                onChange={(e) => handlePanChange(e, setFieldValue, false)}
              />
            </Grid>
            {/* <PhotoField
                  name="guarantorPanPhoto"
                  label="Pan Image"
                  handleFileUpload={handleFileUpload}
                /> */}

            {/* <Grid item xs={3}>
                  <Typography mt={1}>Guarantor Driving Licence</Typography>
                  <Field
                    fullWidth
                    size="small"
                    name="guarantorDrivingLicence"
                    as={TextField}
                    sx={{
                      "& .MuiInputBase-root": {
                        // Smaller font size
                        borderRadius: "8px", // Adjust this value for border radius
                      },
                    }}
                  />
                </Grid> */}
            {/* <PhotoField
                  name="guarantorDrivingLicencePhoto"
                  label="Guarantor Driving licence Image"
                  handleFileUpload={handleFileUpload}
                /> */}

            <Grid item xs={3}>
              <Typography mt={1}>Guarantor Cheque Number</Typography>
              <Field
                fullWidth
                size="small"
                name="guarantorChequeNumber"
                as={TextField}
                onKeyDown={(e) => {
                  // Allow only numbers
                  if (
                    !/[0-9]/.test(e.key) && // Allow digits
                    e.key !== "Backspace" && // Allow Backspace
                    e.key !== "Delete" && // Allow Delete
                    e.key !== "ArrowLeft" && // Allow Left Arrow
                    e.key !== "ArrowRight" // Allow Right Arrow
                  ) {
                    e.preventDefault();
                  }
                }}
                inputProps={{
                  maxLength: 18, // Restrict length to 10
                }}
                sx={{
                  "& .MuiInputBase-root": {
                    // Smaller font size
                    borderRadius: "8px", // Adjust this value for border radius
                  },
                }}
              />
            </Grid>
            {/* <PhotoField
                  name="guarantorChequePhoto"
                  label="Guarantor Cheque Image"
                  handleFileUpload={handleFileUpload}
                /> */}
          </Grid>
        );

      default:
        return <div>Not Found</div>;
    }
  };

  return (
    <Paper sx={{ background: "#fff" }}>
      <Box sx={{ width: "100%", p: 3 }}>
        <Box mb={2}>
          <Stepper activeStep={activeStep}>
            {steps.map((label, index) => (
              <Step key={index}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
        </Box>

        <Formik
          enableReinitialize // Allow reinitializing with new values
          initialValues={{
            userName: customer?.user?.userName || "",
            phoneNumber: phoneNumber || "",
            userPhoto: customer?.user?.userPhoto || "",
            alternativePhoneNumber1: alternativePhoneNumber1 || "",
            alternativePhoneNumber2: "",
            password: "",
            email: email || "",
            address: customer?.address?.address || "",
            landmark: customer?.address?.landmark || "",
            housePhoto: customer?.address?.housePhoto || "",
            locationLink: customer?.address?.locationLink || "",
            workLocationLink: customer?.address?.workLocationLink || "",
            aadhaarNumber: customer?.documents?.aadhaarNumber || "",
            aadhaarPhoto: customer?.documents?.aadhaarPhoto || "",
            panNumber: customer?.documents?.panNumber || "",
            panPhoto: customer?.documents?.panPhoto || "",
            rc: "",
            rcHolderName: customer?.documents?.rcHolderName || "",
            rcPhoto: customer?.documents?.rcPhoto || "",
            chequeNumber: customer?.documents?.chequeNumber || "",
            chequePhoto: customer?.documents?.chequePhoto || "",
            propertyHolderName: customer?.documents?.propertyHolderName || "",
            propertyPhoto: customer?.documents?.propertyPhoto || "",
            loanIssuedOn: customer?.documents?.loanIssuedOn || "",
            accountNumber: customer?.documents?.accNumber || "",
            accountName: "",

            IFSC: customer?.documents?.bankIFSCCode || "",
            branch: customer?.documents?.bankBranchName || "",
            bankName: customer?.documents?.bankName || "",
            passBookImage: customer?.documents?.passBookImage || "",
            signatureImage: customer?.documents?.signatureImage || "",
            guarantorName:
              customer?.guarantorDetails?.guarantor?.guarantorName || "",
            guarantorPhoto: "",
            guarantorPhoneNumber:
              customer?.guarantorDetails?.guarantor?.guarantorPhoneNumber || "",
            guarantorAddress:
              customer?.guarantorDetails?.guarantorAddress?.address || "",
            guarantorLandmark:
              customer?.guarantorDetails?.guarantorAddress?.landmark || "",
            guarantorHousePhoto: "",
            guarantorLocationLink: "",
            guarantorAadhaarNumber:
              customer?.guarantorDetails?.guarantorDocuments?.aadhaarNumber ||
              "",
            guarantorAadhaarPhoto: "",
            guarantorPanNumber:
              customer?.guarantorDetails?.guarantorDocuments?.panNumber || "",
            guarantorPanPhoto: "",
            guarantorDrivingLicence: "",
            guarantorDrivingLicencePhoto: "",
            guarantorChequeNumber: "",
            guarantorChequePhoto: "",
            // agent: "",
            // loanAmount: "",
            // frequency: "",
            // collectionDay: "",
            // startDate: "",
            // endDate: "",
            // processingFee: 0,
            // interestAmount: 0,
            // loanTenure: "",
            // amountToBePaidBy: "",
            // disbursedAmount: "",
            // collectionAmount: "",
            // interest: 5,
            // insuranceFee: 0,
            // penaltyAmount: 0,
          }}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ isSubmitting, values, setFieldValue, handleChange }) => (
            <Box sx={{ px: 2 }}>
              <Form>
                {renderStepContent(
                  activeStep,
                  values,
                  setFieldValue,
                  handleChange
                )}
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    mt: 2,
                  }}
                >
                  <Button disabled={activeStep === 0} onClick={handleBack}>
                    Back
                  </Button>
                  <Button
                    variant="contained"
                    type="submit"
                    disabled={isSubmitting}
                    sx={{ borderRadius: "8px" }}
                  >
                    {isLastStep ? "Submit" : "Next"}
                  </Button>
                </Box>
              </Form>
            </Box>
          )}
        </Formik>
      </Box>
    </Paper>
  );
};

export default CreateGroupCustomer;
